import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale';
import zh from './langs/zh'
import en from './langs/en'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

// 全局挂载 VueI18n
Vue.use(VueI18n)

// 创建 i18n 实例，并引入语言文件
const messages = {
  en: Object.assign(en, enLocale),
  zh: Object.assign(zh, zhLocale)
}

/**
 * 切换语言包
 */
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh',    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages
})

//为了实现element插件的多语言切换
locale.i18n((key, value) => i18n.t(key, value))

export default i18n


// WEBPACK FOOTER //
// ./src/language/i18n.js